export function getSlideId() {
  var id = window.tnsId;
  window.tnsId = !id ? 1 : id + 1;
  
  return 'tns' + window.tnsId;
}


//////////////////
// WEBPACK FOOTER
// /Users/remimichel/workspace/rwigo/psip/wp-content/themes/psip/node_modules/tiny-slider/src/helpers/getSlideId.js
// module id = 160
// module chunks = 0